import {schema} from 'normalizr'

const panel = new schema.Entity('objects',{},{idAttribute:'short'})
export default panel